import React from "react";
import Hero from "../components/Hero";
import ServicesGrid from "../components/ServicesGrid";
import { IndustriesSection, ApproachSection, WhyChooseUs, TestimonialsSection, AccreditationBar, ClientsMarquee } from "../components/Sections";
import CaseStudiesSection from "../components/CaseStudiesSection";
import ContactCTA from "../components/ContactCTA";

const HomePage = () => (
  <>
    <Hero />
    <ClientsMarquee />
    <ServicesGrid limit={9} />
    <WhyChooseUs />
    <ApproachSection />
    <CaseStudiesSection limit={3} />
    <IndustriesSection limit={8} />
    <TestimonialsSection />
    <AccreditationBar />
    <ContactCTA />
  </>
);

export default HomePage;
